import { Card, Skeleton } from 'antd'

import styles from './InspirationCard.module.css'

const InspirationSkeletonCard = () => (
    <Card className={styles.galleryCard} hoverable={false}>
        <div className={styles.cardContent}>
            <div className={styles.inspirationSkeletonPreview}>
                <Skeleton.Image
                    active
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                />
            </div>
            <div className={styles.cardHeader}>
                <Skeleton.Avatar
                    active
                    size={44}
                    shape="square"
                    style={{ borderRadius: 12, flexShrink: 0 }}
                />
                <div className={styles.galleryInfo}>
                    <Skeleton
                        active
                        title={false}
                        paragraph={{
                            rows: 2,
                            width: ['78%', '48%'],
                        }}
                    />
                </div>
            </div>
            <Skeleton
                active
                title={false}
                paragraph={{
                    rows: 2,
                    width: ['60%', '40%'],
                }}
            />
        </div>
    </Card>
)

export default InspirationSkeletonCard
